import React from 'react';
import { FaLock } from 'react-icons/fa';

export default function Decisions({ readOnly }) {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-bold text-gray-800">Entscheidungsprotokolle</h3>
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-8 text-center">
        <FaLock className="text-3xl text-slate-600 mx-auto mb-4" />
        <p className="text-gray-700 mb-2">Die Verwaltung des Beschlussbuchs wird in Kürze ergänzt.</p>
        <p className="text-sm text-gray-600">
          Finanzbeschlüsse und Sitzungsprotokolle werden in diesem Modul gespeichert.
        </p>
      </div>
    </div>
  );
}

